import ChangeTheme from './ChangeTheme/index.js';
import Frameset from './Frameset/index.js';
import PersonSetting from './PersonSetting/index.js';
import PersonCenter from './PersonCenter/index.js';
import TagGroup from './TagGroup/index.js';
import NavBar from './NavBar/index.js';
import LoginView from './LoginView/index.js';
import Layout from './Layout/index.js';
import NotFound from './404/index.js';
import PersonalLog from './PresonalLog/index.js';
import SysLogConfig from './SysLogConfig/index.js';
import SubWindow from './SubWindow/index.js';
import WebView from './WebView/index.js';
import KeepAlive from './KeepAlive/index.js';
import kiafRouter from '../router/index.js';
import loginMixins from './LoginView/src/mixins/login';
import zoomMixins from './Layout/src/mixins/zoom';
import personalCenterMixins from './PersonCenter/src/mixins';
import kiaf from '../store/index.js';
import Util from '../utils/util.js';
import Global from '../utils/global.js';
import Auth from '../utils/auth.js';
import Constants from '../utils/constants.js';
import Ajax from '../utils/ajax/index.js';
import AjaxConfig from '../utils/ajax/config';
import Comm from '../utils/comm.js';
import {postMessage, onMessage} from '../utils/event-bus';
import Logger from '../utils/logger.js';
const components = [
    ChangeTheme,
    PersonSetting,
    PersonCenter,
    TagGroup,
    NavBar,
    LoginView,
    Layout,
    NotFound,
    PersonalLog,
    SysLogConfig,
    SubWindow,
    WebView,
    KeepAlive,
    Frameset
];
const install = function (Vue, opts = {}) {
    components.forEach(component => {
        Vue.component(component.name, component);
    });
    if(opts.env){
        Comm.setEnv(opts.env);
    }
    if(opts.layout){
        Comm.setLayout(opts.layout);
    }
    if(opts.contentPath){
        Comm.setContentPath(opts.contentPath);
    }
    Global.setVue(Vue);
    if(Vue.version.indexOf('3.') == 0){
        Vue.config.globalProperties.$global = Global;
        Vue.config.globalProperties.$util = Util;
        Vue.config.globalProperties.$auth = Auth;
        Vue.config.globalProperties.$constants = Constants;
        Vue.config.globalProperties.$axios = Ajax;
        Vue.config.globalProperties.$onMessage = onMessage;
        Vue.config.globalProperties.$postMessage = postMessage;
        Vue.config.globalProperties.$logger = Logger; // 日志记录
        // 增加 $set 方法，兼容在 Vue3 中使用 this.$set
        Vue.config.globalProperties.$set = (obj, key, value) => {
            obj[key] = value;
        };
    } else {
        Vue.prototype.$global = Global;
        Vue.prototype.$util = Util;
        Vue.prototype.$auth = Auth;
        Vue.prototype.$constants = Constants;
        Vue.prototype.$axios = Ajax;
        Vue.prototype.$onMessage = onMessage;
        Vue.prototype.$postMessage = postMessage;
        Vue.prototype.$logger = Logger; // 日志记录
    }

    // 捕获全局错误信息
    Vue.config.errorHandler = function (err, vm, info) {
        // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
        console.error('errorHandler --- ', err);

        let logData = {
            type: 'error',
            error: {
                message: err.toString(),
                fileName: err.fileName || '',
                lineNumber: err.lineNumber || ''
            }
        };
        Logger.addLog(logData);
    };
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}
export {
    ChangeTheme,
    PersonSetting,
    PersonCenter,
    TagGroup,
    NavBar,
    LoginView,
    Layout,
    NotFound,
    PersonalLog,
    SysLogConfig,
    SubWindow,
    WebView,
    KeepAlive,
    loginMixins,
    zoomMixins,
    personalCenterMixins,
    Frameset,
    kiafRouter,
    kiaf,
    Util,
    Global,
    Auth,
    Constants,
    Ajax,
    AjaxConfig,
    postMessage,
    onMessage
};

export default {
    version: '2.2.0',
    install,
    ChangeTheme,
    PersonSetting,
    PersonCenter,
    TagGroup,
    NavBar,
    LoginView,
    Layout,
    NotFound,
    PersonalLog,
    SysLogConfig,
    SubWindow,
    WebView,
    KeepAlive
};
